export default __webpack_public_path__ + "static/ccl-57b8548453ca7401cb847bf617dba9ed.jpg";